<template>
  <div class="settings--content">
    <div class="prechat--title">
      {{ $t('INBOX_MGMT.PRE_CHAT_FORM.DESCRIPTION') }}
    </div>
    <form class="medium-6" @submit.prevent="onSubmitUpdate">
      <label class="medium-9 columns">
        {{ $t('INBOX_MGMT.PRE_CHAT_FORM.ENABLE.LABEL') }}
        <select v-model="preChatFormEnabled">
          <option :value="true">
            {{ $t('INBOX_MGMT.PRE_CHAT_FORM.ENABLE.OPTIONS.ENABLED') }}
          </option>
          <option :value="false">
            {{ $t('INBOX_MGMT.PRE_CHAT_FORM.ENABLE.OPTIONS.DISABLED') }}
          </option>
        </select>
      </label>

      <label class="medium-9">
        {{ $t('INBOX_MGMT.PRE_CHAT_FORM.PRE_CHAT_MESSAGE.LABEL') }}
        <textarea
          v-model.trim="preChatMessage"
          type="text"
          :placeholder="
            $t('INBOX_MGMT.PRE_CHAT_FORM.PRE_CHAT_MESSAGE.PLACEHOLDER')
          "
        />
      </label>
      <div>
        <input
          v-model="preChatFieldOptions"
          type="checkbox"
          value="requireName"
          @input="handlePreChatFieldOptions"
        />
        <label for="requireName">
          Visitors should provide their name
        </label>
      </div>
      <div>
        <input
          v-model="preChatFieldOptions"
          type="checkbox"
          value="requireEmail"
          @input="handlePreChatFieldOptions"
        />
        <label for="requireEmail">
          Visitors should provide their email address
        </label>
      </div>
      <div>
        <input
          v-model="preChatFieldOptions"
          type="checkbox"
          value="requirePhoneNumber"
          @input="handlePreChatFieldOptions"
        />
        <label for="requirePhoneNumber">
          Visitors should provide their phone number
        </label>
      </div>
      <woot-submit-button
        :button-text="$t('INBOX_MGMT.SETTINGS_POPUP.UPDATE')"
        :loading="uiFlags.isUpdatingInbox"
      />
    </form>
    <woot-confirm-updating-modal
      :show.sync="showUpdatePopup"
      :on-confirm="updateInbox"
      :on-close="closeUpdating"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';

export default {
  mixins: [alertMixin],
  props: {
    inbox: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showUpdatePopup: false,
      preChatFormEnabled: false,
      preChatMessage: '',
      preChatFieldOptions: [],
    };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
  },
  watch: {
    inbox() {
      this.setDefaults();
    },
  },
  mounted() {
    this.setDefaults();
  },
  methods: {
    setDefaults() {
      const {
        pre_chat_form_enabled: preChatFormEnabled,
        pre_chat_form_options: preChatFormOptions,
      } = this.inbox;
      this.preChatFormEnabled = preChatFormEnabled;
      const { pre_chat_message: preChatMessage, require_email: requireEmail, require_name: requireName, require_phone_number: requirePhoneNumber } =
        preChatFormOptions || {};
      this.preChatMessage = preChatMessage;
      this.preChatFieldOptions = [];
      if (requireEmail) {
        this.preChatFieldOptions.push('requireEmail');
      }
      if (requireName) {
        this.preChatFieldOptions.push('requireName');
      }
      if (requirePhoneNumber) {
        this.preChatFieldOptions.push('requirePhoneNumber');
      }
    },
    handlePreChatFieldOptions(event) {
      if (this.preChatFieldOptions.includes(event.target.value)) {
        let index = this.preChatFieldOptions.indexOf(event.target.value);
        this.preChatFieldOptions.splice(index, 1);
      } else {
        this.preChatFieldOptions.push(event.target.value);
      }
    },
    onSubmitUpdate(){
      this.showUpdatePopup = true;
    },
    closeUpdating(){
      this.showUpdatePopup = false;
    },
    async updateInbox() {
      try {
        const payload = {
          id: this.inbox.id,
          formData: false,
          channel: {
            pre_chat_form_enabled: this.preChatFormEnabled,
            pre_chat_form_options: {
              pre_chat_message: this.preChatMessage,
              require_email: this.preChatFieldOptions.includes('requireEmail'),
              require_name: this.preChatFieldOptions.includes('requireName'),
              require_phone_number: this.preChatFieldOptions.includes('requirePhoneNumber'),
            },
          },
        };
        await this.$store.dispatch('inboxes/updateInbox', payload);
        this.showAlert(this.$t('INBOX_MGMT.EDIT.API.SUCCESS_MESSAGE'));
      } catch (error) {
        this.showAlert(this.$t('INBOX_MGMT.EDIT.API.SUCCESS_MESSAGE'));
      }
      this.showUpdatePopup = false;
    },
  },
};
</script>
<style scoped>
.settings--content {
  font-size: var(--font-size-default);
}

.prechat--title {
  margin: var(--space-medium) 0 var(--space-slab);
}
</style>
